import { mask, unmask } from './mask-fn'

export default mask
export { mask, unmask }
